import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { Meeting } from '../../services';

export type MeetingState = {
  meetings: Partial<Meeting>[];
  selectedMeeting: Partial<Meeting> | null;
  setSelectedMeetings: (meetings: Meeting) => void;
  setMeetings: (meetings: Meeting[]) => void;
};

const useMeetingStore = create(
  persist<MeetingState>(
    set =>
      ({
        meetings: [],
        selectedMeeting: null,
        setSelectedMeetings: (meeting: Meeting) =>
          set({
            selectedMeeting: meeting,
          }),
        setMeetings: (meetings: Meeting[]) =>
          set({
            meetings,
          }),
      } as MeetingState),
    {
      name: '@tenGovUseMeetingStore',
    },
  ),
);

export default useMeetingStore;
